import { render, staticRenderFns } from "./index-beifen.vue?vue&type=template&id=46bf26ca&"
import script from "./index-beifen.vue?vue&type=script&lang=js&"
export * from "./index-beifen.vue?vue&type=script&lang=js&"
import style0 from "./index-beifen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports